export const FormatMarketingSpendData = ({SPAN_TYPE,FORM_DATA}) => {
    if(SPAN_TYPE==="last_month_marketing_spend") return FORM_DATA;
    return FORM_DATA.map((data) => {
        let months = {}
        data.last_six_months.map((subdata,index) => {
            months = { ...months, [`month${index+1}`]: subdata.spend_value }
        })
        return { "name": data.name, ...months }
    })
}